/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_008: Question = {
  id: 'multi-008-politique-arbre',
  oldId: '69',
  title: 'Adoption d\'une Politique de l\'arbre',
  number: '6.4',
  description: ['Actions en faveur des arbres'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 9,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_008__v3: Question = {
  ...question_multi_008,
  title: 'Mise en oeuvre d\'une Politique de l\'arbre',
  frequency: 1,
};

export const question_multi_008_v2: Question = question_multi_008;
export const question_multi_008_v3: Question = question_multi_008__v3;
